import React from "react"
import PublicationCard from '../components/PublicationCard'
import '../styles/publications.css'
export default function Publications(){
    const [publications,setPublications] = React.useState([]);

    const callPublicationPage = async () => {
        try {
          const res = await fetch('https://portfolio-server-ojasketkar.vercel.app/getAllPublications', {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            },
          });
    
          const data = await res.json();
          setPublications(data.data);
          
        //   console.log(data)
          if (!res.status === 200) {
            const error = new Error(res.error);
            throw error;
          }
        } catch (error) {
          console.log(error);
        }
      };
    

      React.useEffect(() => {
        callPublicationPage();
      }, []);
    
    return(
        <div className="publications">
            <h3 className="publication_tagline">Unveiling Insights</h3>
            <h1 className="publication-header">Research Papers</h1>

            <div className="publication-grid">
                <PublicationCard
                publications = {[...publications]}
                />
            </div>
        </div>
    )
}